import { IAssessmentQuestionType, IOngoingAssessmentResponse } from '@sondermind/utilities/models-assessments';

export const CREATE_RESPONSE_RESPONSE: IOngoingAssessmentResponse = {
  response: {
    _id: '60a1b2c3d4e5f6g7h8i9j0k4',
    assignmentId: '60a1b2c3d4e5f6g7h8i9j0k3',
    clientId: 12345,
    answers: [],
    createdAt: new Date('2023-06-15T10:35:00.000Z'),
    lastUpdatedAt: new Date('2023-06-15T10:35:00.000Z')
  },
  currentQuestion: {
    questionId: 'q1',
    text: 'How often do you have a drink containing alcohol?',
    type: IAssessmentQuestionType.MULTIPLE_CHOICE,
    options: ['Never', 'Monthly or less', '2-4 times a month', '2-3 times a week', '4 or more times a week']
  },
  isComplete: false
};
